/**
 * @generated SignedSource<<3b01303945aa0596c6d6bea2efdf3c1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTaskCreateDialog_brandMessageTemplate$data = {
  readonly content: string;
  readonly id: string;
  readonly parameterNames: ReadonlyArray<string>;
  readonly " $fragmentType": "BrandMessageTaskCreateDialog_brandMessageTemplate";
};
export type BrandMessageTaskCreateDialog_brandMessageTemplate$key = {
  readonly " $data"?: BrandMessageTaskCreateDialog_brandMessageTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTaskCreateDialog_brandMessageTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageTaskCreateDialog_brandMessageTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parameterNames",
      "storageKey": null
    }
  ],
  "type": "BrandMessageTemplate",
  "abstractKey": null
};

(node as any).hash = "fb2dc9f50edae69df6c4aced7f0a8198";

export default node;
